import React, { useContext, useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { Oval } from 'react-loader-spinner'
import { listaConsultoraContext } from '../../../Admin/superAdmin/ListaConsultoras';
import "../ModalAdmin.scss"
import { useAdmin } from '../../../../context/AdminContext';

function ModalEmpConsul(props) {

    const { user, idConsultora, idEmpleado, setIdEmpleado, objEmpleado, setObjEmpleado } = useContext(listaConsultoraContext)
    
    const { fetchEmpleadoConsultoraById, setLoadingEmpConsul } = useAdmin() 

    const [newUser, setNewUser] = useState({
        nombre: "",
        mail: ""
    })

    const [errors, setErrors] = useState({})
    const [modalErr, setModalErr] = useState(null)

    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(objEmpleado){
            const obj = JSON.parse(objEmpleado)
            setNewUser({
                nombre: obj.nombre,
                mail: obj.mail
            })
        }
    }, [objEmpleado])

    const handleClose = () => {
        setErrors({})
        setNewUser({
            nombre: "",
            mail: ""
        })
        setObjEmpleado(null)
        setIdEmpleado(null)
        setModalErr(null)
        props.onHide()
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewUser({
            ...newUser,
            [name]: value,
        })
    }

    const validateForm = (data) => {
        const errors = {}
        if(!data.nombre.trim()) {
            errors.nombre = "Escriba el nombre del empleado."
        }
        if(!data.mail.trim()) {
            errors.mail = "Escriba el mail."
        } else if (!/\S+@\S+\.\S+/.test(data.mail)){
            errors.mail = "El email no es válido."
        }
        return errors
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newUser);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setModalErr(null)
            setLoading(true)
            const obj = {
                user,
                idConsultora,
                fk_puesto: 2,
                nombre: newUser.nombre,
                mail: newUser.mail
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/addUser`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.status ?? data.error
                if(errorCode !== 0){
                    setModalErr(data.codeError || data.errorDetalle)
                } else {
                    handleClose()
                    // actualizar empleados
                    setLoadingEmpConsul(true)
                    fetchEmpleadoConsultoraById(user, idConsultora)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    const handleChangeEmpleado = async (e) => {
        e.preventDefault()
        const newErrors = validateForm(newUser);
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setModalErr(null)
            setLoading(true)
            const obj = {
                user,
                idUser: idEmpleado,
                fk_puesto: 2,
                nombre: newUser.nombre,
                mail: newUser.mail
            }
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/editUser`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const errorCode = data.status ?? data.error
                if(errorCode !== 0){
                    setModalErr(data.codeError || data.errorDetalle)
                } else {
                    handleClose()
                    // actualizar empleados
                    setLoadingEmpConsul(true)
                    fetchEmpleadoConsultoraById(user, idConsultora)
                }
            } catch (error) {
                setModalErr("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setModalErr("Completar los campos mencionados.")
        }
    }

    return (
        <>
            {loading && <div className='loading__modalEmpleado' role='status'>
                    <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#fff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='text-white fw-medium'>Loading...</p>
                </div>
            }
            <Modal
                {...props}
                // size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                className='modal__empleado'
                dialogClassName={props.dialogClassName}
            >
                <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter" className='d-flex flex-row'>
                        {objEmpleado ? <h3 className='m-0'>Modificar empleado</h3>: <h3 className='m-0'>Agregar empleado</h3>}
                        <button className='btn' onClick={handleClose}><i className="bi bi-x-lg fw-bold"></i></button>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {objEmpleado ? (
                        <form className='form__empleado d-flex flex-column' onSubmit={handleChangeEmpleado}>
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre</label>
                                <input
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombre" 
                                    name="nombre" 
                                    autoFocus
                                    className="form-control form-control-sm col-12"
                                    value={newUser.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            <div className='mb-2'>
                                <label className='mb-1'>Correo</label>
                                <input
                                    onChange={handleChange}
                                    type="email" 
                                    id="mail" 
                                    name="mail" 
                                    placeholder="usuario@correo.com.ar" 
                                    className="form-control form-control-sm col-12"
                                    value={newUser.mail}
                                />
                                {errors.mail && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.mail}</span>}
                            </div>
                            {modalErr !== null && <span className='form__error text-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                            >
                                Modificar empleado
                            </button>
                        </form>
                    ) : (
                        <form className='form__empleado d-flex flex-column' onSubmit={handleSubmit}>
                            <div className='mb-2'>
                                <label className='mb-1'>Nombre</label>
                                <input
                                    onChange={handleChange}
                                    type="text" 
                                    id="nombre" 
                                    name="nombre" 
                                    autoFocus
                                    className="form-control form-control-sm col-12"
                                    value={newUser.nombre}
                                />
                                {errors.nombre && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.nombre}</span>}
                            </div>
                            <div className='mb-2'>
                                <label className='mb-1'>Correo</label>
                                <input
                                    onChange={handleChange}
                                    type="email" 
                                    id="mail" 
                                    name="mail" 
                                    placeholder="usuario@correo.com.ar" 
                                    className="form-control form-control-sm col-12"
                                    value={newUser.mail}
                                />
                                {errors.mail && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.mail}</span>}
                            </div>
                            {modalErr !== null && <span className='form__error text-center text-danger my-2'><i className="bi bi-exclamation-circle me-1"></i>{modalErr}</span>}
                            <button 
                                type='submit' 
                                className='mt-2 px-4 btn btn-primary rounded-pill shadow-sm fw-medium align-self-center'
                            >
                                Agregar empleado
                            </button>
                        </form>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalEmpConsul